export interface EventMeta {
  label: string;
  /** One-line explanation shown on hover. */
  tip: string;
}

/**
 * Human label + explanation for each `console_events` event_type. The 系统事件
 * tab is mostly system telemetry; without this it printed raw machine strings
 * like "api_request". Fallback is the raw type so an unmapped event still shows.
 */
const EVENT_META: Record<string, EventMeta> = {
  api_request: { label: "接口请求", tip: "一次后端 API 请求（方法 / 路径 / 状态码 / 延迟）" },
  presence_sample: { label: "在线心跳", tip: "前端定时上报的在线状态采样，用于统计当前在线用户" },
  turn_completed: { label: "对话回合完成", tip: "一轮问答完成——记录答案来源（知识库 / 联网 / 兜底）等结果" },
  chat_outcome: { label: "对话结果（旧）", tip: "回合结果的历史事件，已被「对话回合完成」取代" },
  conversation_created: { label: "新建会话", tip: "用户开启了一个新会话" },
  conversation_deleted: { label: "删除会话", tip: "会话被软删除（保留历史，当前视图中隐藏）" },
  login: { label: "登录", tip: "用户登录" },
  cache_serve: { label: "缓存命中", tip: "本轮回答由缓存（L2 / L3）直接给出" }
};

export function eventMeta(eventType: string): EventMeta {
  return EVENT_META[eventType] ?? { label: eventType, tip: "系统事件" };
}
